import { API_ENDPOINTS } from '@/utils/endpoints';
import { BaseService } from '../baseService';
import { Client } from '../models/Client';
import { Customer } from '../models/Customer';
import { BaseContract, Contract, ContractRequestPayload } from '../models/Contracts';
import { ClientRequest, ContractByCustomerRequest, CustomerRequest } from '../models/BaseRequest';
import { RecentSearch } from '../models/RecentSearch';

export class ContractService {
  static fetchClients = async (request: ClientRequest): Promise<Client[]> => {
    return await BaseService.post<Client[]>(API_ENDPOINTS.GET_CLIENT, request);
  };

  static fetchCustomers = async (request: CustomerRequest): Promise<Customer[]> => {
    return await BaseService.post<Customer[]>(API_ENDPOINTS.GET_CUSTOMER_BY_CLIENT, request);
  };

  static fetchContracts = async (
    endpoint: string,
    payload: ContractRequestPayload,
  ): Promise<Contract[]> => {
    return await BaseService.post<Contract[]>(endpoint, payload);
  };

  static fetchRecentContracts = async (userId: string): Promise<Contract[]> => {
    return await BaseService.post<Contract[]>(API_ENDPOINTS.GET_CONTRACT_RECENT_SEARCH, {
      userId,
    });
  };

  static postRecentSearch = async (searchData: RecentSearch) => {
    return await BaseService.post(API_ENDPOINTS.POST_CONTRACT_RECENT_SEARCH, searchData);
  };

  static fetchContractsByCustomer = async (
    request: ContractByCustomerRequest,
  ): Promise<BaseContract[]> => {
    return await BaseService.post<BaseContract[]>(API_ENDPOINTS.GET_CONTRACTS_BY_CUSTOMER, request);
  };
}
